import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import {
  Grid,
  Link,
  Divider,
  Container,
  Typography,
  Stack,
} from "@mui/material";
// routes
import { PATH_PAGE } from "../../routes/paths";
// components
import Logo from "../../components/Logo";
import SocialsButton from "../../components/SocialsButton";

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: "MGN & CO",
    children: [
      { name: "About us", href: PATH_PAGE.about },
      { name: "Contact us", href: PATH_PAGE.contact },
      { name: "FAQs", href: PATH_PAGE.faqs },
    ],
  },
  {
    headline: "Legal",
    children: [
      { name: "Terms and Condition", href: PATH_PAGE.TermesConditions },
      { name: "Privacy Policy", href: PATH_PAGE.PolitiqueConf },
      { name: "Security Policy", href: PATH_PAGE.PolitiqueSecurite },
      { name: "Refund Policy", href: PATH_PAGE.PolitiqueRemboursement },
    ],
  },
  {
    headline: "Other",
    children: [
      { name: "Moderation Policy", href: PATH_PAGE.PolitiqueModeration },
      { name: "Membership Conditions", href: PATH_PAGE.ConditionsAffiliation },
    ],
  },
  {
    headline: "Contact",
    children: [
      { name: "info@sys-mgn-co.com", href: "#" },
      { name: "Parc Midoré, Delmas 33", href: "#" },
    ],
  },
];

const RootStyle = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: "center", md: "space-between" }}
          sx={{ textAlign: { xs: "center", md: "left" } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo mini={false} sx={{ mx: { xs: "auto", md: "inherit" } }} />
          </Grid>
          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              Améliorez la gestion de votre entreprise de loterie avec MGN & CO.
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: "center", md: "flex-start" }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              <SocialsButton
                sx={{ mx: 0.5 }}
                links={{
                  facebook: "https://web.facebook.com/mgn-&-co/",
                  instagram: "https://www.instagram.com/mgn-&-co/",
                  // linkedin: "#",
                  twitter: "https://twitter.com/mgn-&-co",
                }}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack
              spacing={5}
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
            >
              {LINKS.map((list) => (
                <Stack key={list.headline} spacing={2}>
                  <Typography component="p" variant="overline">
                    {list.headline}
                  </Typography>
                  {list.children.map((link) => (
                    <Link
                      to={link.href}
                      key={link.name}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: "block" }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          © 2022. All rights reserved made by &nbsp;
          <Link
            href="https://www.linkedin.com/company/loyaltoservices"
            target="_blank"
            rel="noopener"
          >
            Loyalto Services
          </Link>
        </Typography>
      </Container>
    </RootStyle>
  );
}
